import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';

/*
  Generated class for the BhutilProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
function isPrimitive(value: any): boolean {
  if (value === null) {
      return true;
  }
  const type = typeof value;
  return type !== 'object' && type !== 'function'; // Functions are sometimes considered "object-like" but not the complex objects arrays/classes
}
@Injectable({
    providedIn: 'root'
})
export class BhutilProvider {

  constructor(private toastCtrl: ToastController) {
    console.log('Hello BhutilProvider Provider');
  }

  stringify(jsonObject: any) {
    let result = '';
    let seen = [];

    try {
      result = JSON.stringify(jsonObject);
      return result;
    } catch (error) {
      console.log('bhutil.stringify: stringifying ran into issues - trying more robust way - error = ' + error);
    }
    try {
      console.log('bhutil.stringify - typeof object = ' + (typeof jsonObject));
      result = JSON.stringify(jsonObject, function(key,value) {
        try {
          // console.log("key = " + key + ", typeof value = " + (typeof value));
          if (value != null && typeof value == "object") {
            if (seen.indexOf(value) >= 0) {
              // console.log('bhutil.stringify: CYCLIC STRUCTURE');
              return 'self';
            }
            seen.push(value);
          }
          else {
            if (value != null && (typeof value == 'string' || typeof value == 'number')) {
              return value;
            }
            else {
              return 'unsupported type';
            }
          }
        } catch (error) {
          console.log('bhutil.stringify: error in replace function = ' + error);
        }
      });
      console.log('bhutil.stringify: result = ' + result);
    } catch (error) {
      console.log('bhutil.stringify: error = ' + error);
    }
    return result;
  }

  hiveSize() {
    return Math.round(window.innerWidth/10.6);
  }
  hiveWidth() {
    return window.innerWidth;
  }
  hiveHeight() {
    let hiveSize = this.hiveSize() * 7.5 * 1.45 + 20 + 80 + 100;
    if (hiveSize < 500) {
      return 500;
    }
    else {
      return hiveSize;
    }
  }
  presentToast(text) {
    let toastProm = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toastProm.then((toast) => 
      toast.present()
    );

  }
  public createCopy(source: any): any {

    if (source instanceof String) {
      let sourceString: String = source;
      return new String(sourceString.valueOf());
    }
    else if (source instanceof Number) {
      let sourceNumber: Number = source;
      return new Number(sourceNumber.valueOf());
    }
    else if (source instanceof Boolean) {
      let sourceBoolean: Boolean = source;
      return new Boolean(sourceBoolean.valueOf());
    }
    else if (source instanceof Array) {
      let target: Array<any> = [];
      source.forEach((value, index) => {
        let objectCopy = this.createCopy(value);
        target.push(objectCopy);
      });
      return target;
    }
    else if (source instanceof Object) {
      let sourceObject: Object = source;
      let targetObject: Object = {};
      Object.keys(sourceObject).forEach(key => {
        targetObject[key] = this.createCopy(sourceObject[key]);
      });
      return targetObject;
    }
    else if (isPrimitive(source)) {
        return source;
    }
    else {
      console.log("[beerHiveButton] - createCopy: unknown instance for source " + source);
      return source;
    }
  }

    public getStateParam(router: Router, paramName: string) {
    // 1. Get the navigation object
    let state: any = router.currentNavigation()?.extras?.state;

    // 2. Check if state exists (it might be null if user refreshed page!)
    if (state) {
      let result: any = state.data[paramName]
      console.log("Received Object:", result);
      return result;
    } else {
      // 3. FALLBACK (Important!)
      // If the user refreshes the page, 'state' is wiped clean.
      // You should handle this (e.g., go back or show error).
      console.warn("No state found! User probably refreshed usage.");
    }
  }

  public isToday(dateToCheck: Date): boolean {
    const today = new Date();
    return dateToCheck.toDateString() === today.toDateString();
  }

  public getCallerName(): string {
    const stack = new Error().stack;
    if (!stack) return 'unknown';

    // Split stack into individual lines
    const lines = stack.split('\n');

    // We want the 3rd or 4th line depending on how the utility is called
    // Line 0: Error
    // Line 1: at getCallerName...
    // Line 2: at theFunctionYouAreDebugging...
    // Line 3: at theActualCaller...
    let callerLine = lines[3] || lines[2];

    // look for the first method name different from "log"
    let lineNbr = 2;
    while (lines[lineNbr] && lines[lineNbr].indexOf(".log ") >= 0) lineNbr++;

    callerLine = lines[lineNbr];

    // Regex to extract the function name
    // Chrome/Edge/Node format: "  at FunctionName (path/to/file.ts:12:3)"
    // Firefox/Safari format: "FunctionName@path/to/file.ts:12:3"
    const regex = /at\s+(.*)\s+\(|(\w+)(?=@)/;
    const match = callerLine.match(regex);

    if (match) {
      return match[1] || match[2] || 'anonymous';
    }

    return 'anonymous';
  }
}
